import mirrorCreator from 'mirror-creator';

const constants = mirrorCreator([
  'SELECT_WEBHOOK'
]);

export default constants;
